import { QuickFilterButton } from '../QuickFilterButton';
import type { QuickFiltersProps } from './types';
import { useQuickFilters } from './useQuickFilters';
import { isQuickFilterSelected } from './utils';

function QuickFilters({
  quickFilterActions,
  setFilters,
  filterState,
  variant,
  style,
  toolbarVariant,
}: QuickFiltersProps) {
  const { onClickQuickFilter } = useQuickFilters({ quickFilterActions, setFilters, filterState });
  return quickFilterActions?.map((quickFilter) => {
    return (
      <QuickFilterButton
        isSelected={isQuickFilterSelected(quickFilter, filterState)}
        key={quickFilter.id}
        {...quickFilter}
        appearance={quickFilter.appearance}
        onClickQuickFilter={onClickQuickFilter}
        style={style}
        toolbarVariant={toolbarVariant}
        variant={variant}
      />
    );
  });
}

export default QuickFilters;
